export default __webpack_public_path__ + "static/media/Tik-youtube.396ccfca.svg";